/**
 * Theme colors - reads from CSS variables defined in resources/css/app.css
 *
 * For runtime contexts (Vue components after mount), use getCssColor() to read
 * directly from CSS variables. For build-time contexts (app.ts, SVG files),
 * use the hardcoded fallbacks.
 */

/**
 * Get a CSS color variable value at runtime.
 * Only works after DOM is ready (e.g., in Vue onMounted or later).
 *
 * @param {string} name - Variable name without -- prefix (e.g., 'color-palatinate-500')
 * @returns {string} The color value
 */
export function getCssColor(name) {
    return getComputedStyle(document.documentElement)
        .getPropertyValue(`--${name}`)
        .trim()
}

/**
 * Get brand color at runtime from CSS variables.
 * @param {number} shade - Color shade (50, 100, 200, ..., 950)
 * @returns {string} The color value
 */
export function getBrandColor(shade) {
    return getCssColor(`color-palatinate-${shade}`)
}

/**
 * Hardcoded fallbacks for contexts where CSS variables aren't available:
 * - app.ts (Inertia progress bar runs before DOM)
 * - SVG files (can't use CSS variables)
 * - Chart.js datasets (initialized at module level)
 *
 * These MUST match --color-palatinate-* in resources/css/app.css
 */
export const brand = {
    50: '#EFEFFF',
    100: '#DADAFF',
    200: '#B4B4FF',
    300: '#8F8FFF',
    400: '#6A6AFF',
    500: '#4C4CFF',
    600: '#3E3ED1',
    700: '#3131C2',
    800: '#2424A4',
    900: '#1C1C94',
    950: '#151575',
}
